import { useState, useEffect, FunctionComponent } from "react";
import Topbar from "../../Components/TopBar/TopBar";
import commonStyle from "../common.module.css";
import { connect, useDispatch } from "react-redux";
import { WHATSAPP_COLUMNS } from "../../Values/tables";
import CustomTable from "../../Components/CustomTable/CustomTable";
import { getWhatsAppConfigById, updateWhatsAppConfig } from "../../Services/organizations";
import styles from './WhatsAppIntegration.module.css'
import { themeColors } from "../../Components/theme";
import Loading from "../../Components/Loading/Loading";
import { useMediaQuery } from "@material-ui/core";
import { searchWhatsAppItem } from "../../Values/utils";
import { showSnackbarAction } from "../../Redux/actions";

type props = {
  history: any;
  organizationId: any;
  apiHeaders: any;
  theme: any
};

const WhatsAppIntegrationList: FunctionComponent<props> = ({ history, organizationId, apiHeaders, theme }) => {
  const isMobile = useMediaQuery('(max-width: 900px)');
  const dispatcher = useDispatch();
  const [searchQuery, setsearchQuery] = useState("");
  const [columnModal, setColumnModal] = useState(false);
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [clearFilterTable, setClearFilterTable] = useState(false);
  const [list, setList] = useState<any[]>([]);
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!organizationId || organizationId.trim() === "") {
      console.warn("organizationId empty → skipping Firestore call");
      return;
    }
    setLoading(true);
    const unsub = getWhatsAppConfigById(organizationId, (data) => {
      setList(data);
      setLoading(false);
    });

    return () => unsub();
  }, [organizationId]);


  useEffect(() => {
    if (!organizationId || !list || list.length === 0) return;
    const data = list[0];
    const tableRows = [];
    tableRows.push({
      type: "Simply WhatsApp",
      id: data.simply?.id || "simply-id",
      active: data.simply?.active || false,
      url: data.simply?.url || "-",
    });
    tableRows.push({
      type: "WAPI",
      id: data.wapi?.id || "wapi-id",
      active: data.wapi?.active || false,
      url: data.wapi?.wapi_url || "-",
    });
    tableRows.push({
      type: "ChatSimplified",
      id: data.chatSimplified?.id || "chat-simplified-id",
      active: data.chatSimplified?.active || false,
      url: data.chatSimplified?.url || "https://www.chatsimplified.co/api/v1/",
    });
    setRows(tableRows);
  }, [list]);

  useEffect(() => {
    if (rows) {
      let data: any[] = [];
      rows.forEach((item) => {
        data.push(item);
      });
      setFilterData(data);
    }
  }, [rows]);

  useEffect(() => {
    if (rows) {
      const data = searchWhatsAppItem(
        rows,
        searchQuery
      );
      setFilterData(data);
    }
    // eslint-disable-next-line
  }, [searchQuery, rows]);

  const handleClearFilter = () => {
    setClearFilterTable(prev => !prev);
  };

  const onToggleWhatsApp = async (event: any, row: any) => {
    setLoading(true);

    try {
      const activeValue = event.target.checked;
      const type = row.original.type; // "SIMPLY" or "WAPI"

      if (list.length === 0) {
        setLoading(false);
        return;
      }

      const doc = list[0]; // main Firestore object

      // Build payload so only ONE is active
      const payload: any = {};

      if (type === "Simply WhatsApp") {
        payload.simply = {
          ...(doc.simply || {}),
          active: activeValue
        };
        payload.wapi = {
          ...(doc.wapi || {}),
          active: activeValue ? false : doc.wapi?.active ?? false
        };
        payload.chatSimplified = {
          ...(doc.chatSimplified || {}),
          active: activeValue ? false : doc.chatSimplified?.active ?? false
        };
      }

      if (type === "WAPI") {
        payload.wapi = {
          ...(doc.wapi || {}),
          active: activeValue
        };
        payload.simply = {
          ...(doc.simply || {}),
          active: activeValue ? false : doc.simply?.active ?? false
        };
        payload.chatSimplified = {
          ...(doc.chatSimplified || {}),
          active: activeValue ? false : doc.chatSimplified?.active ?? false
        };
      }

      if (type === "ChatSimplified") {
        payload.chatSimplified = {
          ...(doc.chatSimplified || {}),
          active: activeValue
        };
        payload.simply = {
          ...(doc.simply || {}),
          active: activeValue ? false : doc.simply?.active ?? false
        };
        payload.wapi = {
          ...(doc.wapi || {}),
          active: activeValue ? false : doc.wapi?.active ?? false
        };
      }

      await updateWhatsAppConfig(doc.id, payload);

      dispatcher(showSnackbarAction("Status updated!", "success"));
    } catch (err) {
      console.log(err);
      dispatcher(showSnackbarAction("Error updating status", "error"));
    }

    setLoading(false);
  };

  const topBarStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, width: "97%" }
  const parentStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark }

  return (
    <>
      <div className={styles.parent} style={{ display: "block", marginTop: isMobile ? "6%" : "4%", ...parentStyles }}>
        <div className={commonStyle.topBar} style={{ marginTop: "0px", ...topBarStyles }}>
          {loading && <Loading />}
          <Topbar
            history={history}
            title={"WhatsApp"}
            path={"/whatsApp"}
            onChange={(val) => setsearchQuery(val)}
            filterText="Status"
            setColumnModal={(data) => setColumnModal(data)}
            show={true}
            clearFilter={handleClearFilter}
          />
        </div>
        <div className={commonStyle.parent} style={{ minHeight: "450px" }}>
          <CustomTable
            tableColumns={WHATSAPP_COLUMNS}
            tableRows={filterData}
            selectedRows={selectedRows}
            setSelectedRows={(data) => setSelectedRows(data)}
            tableType="WHATSAPP"
            showColumnModal={columnModal}
            hideColumnModal={() => setColumnModal(false)}
            selectedRowsData={selectedRowsData}
            setSelectedRowsData={(data) => setSelectedRowsData(data)}
            setSearchedItem={(val) => setsearchQuery(val)}
            clearFilterTable={clearFilterTable}
            onToggleWhatsApp={onToggleWhatsApp}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
    organizationUsers: state.organizationUsers.data,
    apiHeaders: state.apiHeaderList.data,
    theme: state.theme.isLightMode,
  };
};
export default connect(mapStateToProps)(WhatsAppIntegrationList);
